import { useGLTF } from "@react-three/drei";
import { ITochiAsset, ITochiChicken } from "@snackpass/snackpass-types";
import React, { useEffect, useState } from "react";
import { getTochiMaterial } from "src/utils/Tochi/TochiMaterials/getTochiMaterial";
import { loadShaderChunks } from "src/utils/Tochi/TochiShaders/TochiShaderChunks";
import { AnimationObjectGroup } from "three";

type Props = {
  asset: ITochiAsset;
  animGroup: AnimationObjectGroup;
  chicken: ITochiChicken;
  visible: boolean;
};

export default function TochiEgg({
  asset,
  animGroup,
  chicken,
  visible,
}: Props) {
  // Fetch model and a separate texture
  const { scene } = useGLTF(asset.rig.asset) as any;

  useEffect(() => {
    if (!scene) return;
    handleSetMaterials();
    animGroup.add(scene);
    return () => {
      animGroup.remove(scene);
    };
  }, [scene]);

  const handleSetMaterials = async () => {
    if (!scene) return;
    loadShaderChunks();
    const mat = getTochiMaterial(asset.material);
    const matShader = await mat.get();
    scene.traverse(async (child: any) => {
      if (child.isMesh) {
        child.material = matShader;
        child.visible = true;
      }
    });
    mat.setChicken(chicken);
  };

  return <primitive object={scene} visible={visible} />;
}
